import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';
import { Injectable } from '@angular/core';
import { RewardsCardDetails as RewardsCardDetails } from '../models/rewards-card';
import { RewardsBusiness } from '../models/rewards-business';
import { ClientRewards } from '../models/client-rewards';
import { FeaturedRewards } from '../models/featured-rewards';
import { RewardsCategories } from '../models/rewards-categories';
import { CoreHttpClient } from '@core-modules/providers/core-http-client/core-http-client';


/*
  Generated class for the RewardsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class RewardsProvider
{

    //#region Constructor

    /**
     * Class constructor
     * @param {CoreHttpClient} private http
     * @param {EnvironmentProvider} private environment
     */
    constructor
    (
        private http: CoreHttpClient,
        private environment: EnvironmentProvider
    )
    {

    }

    //#endregion


    //#region Methods

    /**
     * Get Card details of client
     * @param sessionToken client token
     */
    public getCardDetails(sessionToken: string): Promise<RewardsCardDetails>
    {
        return this.http.get<RewardsCardDetails>(`${this.environment.apiEndpoint}/mobileapp/Rewards/GetCardDetails/${sessionToken}`);
    }

    /**
     * Get Business Rewards
     * @param sessionToken client token
     * @param countryID selected country identifier
     */
    public getRewardsCategoryList(sessionToken: string, countryID: string): Promise<RewardsCategories>
    {
        countryID = (countryID == null ? '' : countryID);
        return this.http.get<RewardsCategories>(`${this.environment.apiEndpoint}/mobileapp/Rewards/GetCategoryList/${sessionToken}?countryId=${countryID}`);
    }

    /**
     * Get Business Rewards
     * @param sessionToken client token
     * @param countryID selected country identifier
     * @param categoryId selected category identifier
     */
    public async getRewardBusinessList(sessionToken: string, countryID: string, categoryID: string): Promise<RewardsBusiness[]>
    {
        let rewardsBusinessList = await this.http.get<RewardsBusiness[]>(`${this.environment.apiEndpoint}/mobileapp/Rewards/GetRewardBusinessList/${sessionToken}?countryId=${countryID}&categoryId=${categoryID}`);
        
        return rewardsBusinessList;
    }

    /**
     * Get Business Rewards
     * @param sessionToken client token
     * @param countryID selected country identifier
     * @param categoryId selected category identifier
     */
    public async getClientRewardsByCategory(sessionToken: string, countryID: string, categoryId: string): Promise<ClientRewards>
    {
        countryID = (countryID == null ? '' : encodeURIComponent(countryID));
        categoryId = (categoryId == null ? '' : encodeURIComponent(categoryId));
        return this.http.get<ClientRewards>(`${this.environment.apiEndpoint}/mobileapp/Rewards/GetClientRewardsByCategory/${encodeURIComponent(sessionToken)}?categoryId=${categoryId}&countryId=${countryID}`);
    }

    /**
     * Get Business Rewards
     * @param sessionToken client token
     * @param countryID selected country identifier
     */
    public async getFeaturedRewards(sessionToken: string, countryID: string): Promise<FeaturedRewards>
    {
        countryID = (countryID == null ? '' : countryID);

        let featuredRewards = await this.http.get<FeaturedRewards>(`${this.environment.apiEndpoint}/mobileapp/Rewards/GetFeaturedRewards/${sessionToken}?countryId=${countryID}`);
        
        // return original FeaturedRewards with updated data
        return featuredRewards;
    }

    /**
     * Get a list of offer categories for a business
     * @param business business to get categories for
     */
    public getBusinessOfferCategories(business: RewardsBusiness): { name: string, icon: string }[]
    {
        let categories = business
            .Offers
            .map(x =>
            {
                return {
                    name: x.CategoryName,
                    icon: x.CategoryIcon
                }
            });

        let icons = categories.map(x => x.icon);

        return categories.filter((x, index) => icons.indexOf(x.icon) === index);
    }

    //#endregion
}